import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const analyticApi = {
  getReportActiveUsersByTime: (request) => {
    const { config } = request
    const { params, ...otherConfig } = config
    if (params.app && params.app == 'all') {
      delete params.app
    }
    if (params.filter && params.filter.toLowerCase() == 'all') {
      delete params.filter
    }

    return instance().get(`pagereport_activeusers_bytime`, {
      params: params,
      ...otherConfig
    })
  },
  getReportActiveUsersByDate: (request) => {
    const { config } = request
    const { params, ...otherConfig } = config
    if (params.app && params.app == 'all') {
      delete params.app
    }
    if (params.filter && params.filter.toLowerCase() == 'all') {
      delete params.filter
    }

    return instance().get(`pagereport_activeusers_bydate`, {
      params: params,
      ...otherConfig
    })
  },
  getReportInbox: (request) => {
    const { config } = request
    const { params, ...otherConfig } = config
    if (params.app && params.app == 'all') {
      delete params.app
    }
    if (params.filter && params.filter.toLowerCase() == 'all') {
      delete params.filter
    }
    if (params.group) {
      params.intentgroup = params.group
      delete params.group
    }

    return instance().get(`pagereport_intents`, {
      params: params,
      ...otherConfig
    })
  },
  getReportComment: (request) => {
    const { config } = request
    const { params, ...otherConfig } = config
    if (params.app && params.app == 'all') {
      delete params.app
    }
    if (params.filter && params.filter.toLowerCase() == 'all') {
      delete params.filter
    }

    return instance().get(`api/analytics/pagereport_comment`, {
      params: params,
      ...otherConfig
    })
  },
  getUserTagReport: (config) => {
    const { page_id, ...otherConfig } = config

    return instance().get(`api/user-tag-report/${page_id}`, {
      ...otherConfig
    })
  }

  //pagereport_activeusers_bydate
  //pagereport_activeusers_bytime
}
export default analyticApi



// WEBPACK FOOTER //
// ./src/api/analytic.js